/* istanbul ignore file */
export default ({
  breakpoints,
  palette: { primary, text },
  spacing: { unit },
  typography: {
    fontFamily,
    fontSize,
    fontWeightHeavy,
    fontWeightLight,
    fontWeightRegular,
    headline1,
    headline3,
    mainTitle
  },
  workflow: { footer }
}) => ({
  totals: {
    display: 'flex',
    alignItems: 'center',
    fontSize: unit * 3.75,
    fontFamily: mainTitle.fontFamily,
    margin: 'auto',
    '& span': {
      marginRight: unit,
      fontSize: unit * 3.75,
      fontWeight: 'bold'
    }
  },
  wrapper: {
    ...footer,
    height: unit * 18.75,
    padding: `${unit * 2.5}px ${unit * 7.5}px`,
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '100%'
  },
  buttonWrapper: {
    display: 'flex',
    alignItems: 'center',
    margin: `0 -${unit}px`,
    paddingTop: unit * 2,

    [`@media only screen and (max-width: ${breakpoints.values.lg}px)`]: {
      flexDirection: 'column',
      alignItems: 'flex-start'
    },
    [`@media only screen and (max-width: ${breakpoints.values.sm}px)`]: {
      display: 'block'
    },

    '& .btn': {
      marginRight: unit
    },
    '& button': {
      margin: `0 ${unit}px`
    }
  },
  link: {
    color: text.light
  },
  subtext: {
    fontWeight: fontWeightLight
  },
  animatingButton: {
    transitionTimingFunction: 'cubic-bezier(0, 0.25, 1)',
    position: 'relative',
    overflow: 'hidden',
    zIndex: '1',
    '&:after': {
      content: '""',
      position: 'absolute',
      bottom: '0',
      left: '0',
      width: '100%',
      height: '100%',
      borderRadius: '10rem',
      zIndex: '-2'
    },
    '&:before': {
      content: '""',
      position: 'absolute',
      bottom: '0',
      left: '0',
      width: '0%',
      height: '100%',
      backgroundColor: primary.darkBackground,
      transition: 'all 0s',
      transitionTimingFunction: 'cubic-bezier(0, 0.25, 1)',
      borderRadius: '10rem',
      zIndex: '-1'
    },
    '&.animating': {
      color: '#fff',
      '&:before': {
        transition: 'all 1s',
        width: '100%'
      }
    }
  },
  footerCurrentAmount: {
    color: footer.color || text.light,
    fontFamily: headline1.fontFamily,
    fontWeight: headline1.fontWeight,
    fontSize: headline1.fontSize,
    marginBottom: `${unit * 2}px`,
    '& span.subtext': {
      fontSize: `${unit * 2.25}px`,
      fontWeight: fontWeightRegular,
      fontFamily: headline1.fontFamily
    }
  },
  footerContainer: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap'
  },
  footerTotal: {
    [`@media (max-width: ${breakpoints.md}px)`]: {
      width: '100%'
    }
  },
  currentFooterAmount: {
    display: 'flex',
    flexDirection: 'column',
    fontFamily: headline3.fontFamily,
    color: '#333333',
    fontSize: headline3.fontSize,
    fontWeight: headline3.fontWeight,
    margin: 'auto',
    paddingRight: '60px',
    borderRight: '1px solid #ccc',
    marginRight: '60px',
    '& span.amount': {
      fontFamily: mainTitle.fontFamily,
      fontSize: mainTitle.fontSize,
      fontWeight: mainTitle.fontWeight
    },
    '& span.subtext': {
      fontSize,
      fontWeight: fontWeightHeavy,
      fontFamily,
      textTransform: 'uppercase'
    },
    [`@media (max-width: ${breakpoints.md}px)`]: {
      borderRight: 'none'
    }
  }
});
